import React from 'react'
import { Tdata } from './Tdata'
import './Testimonials.css'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper';
// Import Swiper styles
import 'swiper/swiper-bundle.css';
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import 'swiper/css/navigation';
import "swiper/css/effect-cards";
import { EffectCards } from "swiper";

// import required modules

import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

import "swiper/css/effect-flip";

import { EffectFlip } from 'swiper'




SwiperCore.use([EffectCoverflow, Pagination, Navigation, Autoplay]);


const Testimonials = () => {


  const { ref, inView } = useInView({
    threshold: 0.3, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const leftVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };
  const topVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };

  

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView, animation]);





  return (
    <section className='testimonial__section' ref={ref}>
      <motion.div variants={topVariants} 
          initial="hidden"
          animate={animation} className='testimonial__div'>
      <h2 className="section__title">my clients say</h2>
      <h4 className="section__subtitle">Testimonials</h4>
      </motion.div>
      <motion.div className="container testimonial" variants={leftVariants} 
          initial="hidden"
          animate={animation}>
      <Swiper className="testimonial__container"


           

              effect={'coverflow'}
              grabCursor={true}
              centeredSlides={true}
              loop={true}
              slidesPerView={3}
              loopedSlides={2}
              spaceBetween={30}
              coverflowEffect={{
                rotate: 50,
                transaltey:0,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: false,
                
              }}
             
              
              
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }}
              >
                                     
      
      
      
      
        {Tdata.map(({id, image , title ,description }) => {
          return (
            <SwiperSlide className="testimonial__card" key={id}>
              <img src={image} alt="" className='testimonial__img'/>
              <h3 className="testimonial__name">{title}</h3>
              <p className="testimonial__description">{description}</p>
            </SwiperSlide>
          )
        })}
      </Swiper>
      <Swiper className="testimonial__container-mobile"

          effect={"flip"}
          grabCursor={true}
          pagination={true}
          loop={true}
         
           
        
          modules={[EffectFlip, Pagination, Navigation]} >
                                     
      
      
      
      
        {Tdata.map(({id, image , title ,description }) => {
          return (
            <SwiperSlide className="testimonial__card-mobile" key={id}>
              <img src={image} alt="" className='testimonial__img'/>
              <h3 className="testimonial__name">{title}</h3>
              <p className="testimonial__description">{description}</p>
            </SwiperSlide>
          )
        })}
      </Swiper>
      </motion.div>

    </section>
  )
}

export default Testimonials